import React, { useContext, useEffect, useState } from "react";
import { Button, Grid } from "@mui/material";
import "../../../../../src/styles/Layout/Admin_Styles/_QuestionImgReport.scss";
import Question from "../../../../assets/Question.png";
import { AuthContext } from "../../../../context/AuthContext";
import { authHttp } from "../../../services/utility";
import { apisPath } from "../../../../utils/path";
import { useLocation } from "react-router-dom";
import { encrypt } from "../../../../utils/encryptDecrypt";

const QuestionImgReport = () => {
  const { setIsLoading, setAlertState } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const { state } = useLocation();

  const imgURLPrefix =
    "https://ukpscnet.in/dr-insp-2023/assets/exam-questions/";

  useEffect(() => {
    if (state) {
      getData(state?.paper?.id);
    }
  }, [state]);

  const getData = (subject_id) => {
    setIsLoading(true);
    authHttp
      .get(
        `${apisPath?.admin?.questionImgWiseObjections}/${btoa(
          encrypt(subject_id)
        )}/${state?.type}`
      )
      .then((res) => {
        setData(res?.data?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setAlertState((prev) => ({
          ...prev,
          open: true,
          title: err?.response?.data?.msg,
          btnTxt: "CLOSE",
          status: "fail",
          isSessionExpire: err?.response?.status === 401,
          sessionType: "admin",
        }));
      });
  };

  const handlePrint = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.print(element);
    }
  };
  return (
    <div className="questionImg-report rotate-container" id="print">
      {data.length > 0 && (
        <div className="questionImg-report--print">
          <Button variant="contained" onClick={() => handlePrint("print")}>
            Print
          </Button>
        </div>
      )}
      {data.map((ques, index) => (
        <div className="pagebreak--div">
          <div className="pagebreak">
            <div className="questionImg-report--header">
              <h2>
                Online Objection on Answer Keys of Drug Inspector (Grade-2)
                Exam-2023.
                <br /> औषधि निरीक्षक (ग्रेड-2) परीक्षा - 2023 की उत्तरकुंजियों
                के सापेक्ष ऑनलाइन आपत्ति दर्ज किये जाने हेतु आवेदन <br />
                Advertisement Number: - A-4/DR/DI/S-3/2023-24
              </h2>
              <h3>
                status:{" "}
                <span
                  className={`${
                    state?.type?.toLowerCase() === "paid"
                      ? "text-green"
                      : "text-red"
                  }`}
                >
                  {state?.type}
                </span>
              </h3>
              <h3>
                Subject: {state?.paper?.subject_desc}
                {/* (
                {state?.paper?.subject_code}) */}
              </h3>
            </div>
            <div className="questionImg-report--footerContent-boxWrapper">
              <div className="questionImg-report--footerContent-questions">
                <p>Q.No. {ques?.qno}</p>
                <p>A Acc Q.No. {ques?.a_acc}</p>
                <p>B Acc Q.No. {ques?.b_acc}</p>
                <p>C Acc Q.No. {ques?.c_acc}</p>
                <p>D Acc Q.No. {ques?.d_acc}</p>
              </div>
              <div className="questionImg-report--footerContent-questionImg">
                {ques?.img_path_english && (
                  <div className="questionImg-report--footerContent-questionBox">
                    <img
                      // src={Question}
                      src={`${imgURLPrefix}${ques?.img_path_english}`}
                      alt="questionImg-report-question"
                    />
                  </div>
                )}
                {ques?.img_path_hindi && (
                  <div className="questionImg-report--footerContent-questionBox">
                    <img
                      // src={hindiQuestion}
                      src={`${imgURLPrefix}${ques?.img_path_hindi}`}
                      alt="questionImg-report-question"
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="questionImg-report--asnwerBox">
              <div className="questionImg-report--asnwer">
                <div className="w-50">
                  <p>
                    आयोग की उत्तर कुंजी के अनुसार विकल्प :- {ques?.aayog_answer}
                  </p>
                  <p>
                    उम्मीदवार के अनुसार{" "}
                    <span> :- {ques?.candidate_answers}</span>
                  </p>
                </div>
                <div className="w-50">
                  <p>According to Answer Key of Ayog :- {ques?.aayog_answer}</p>
                  <p>
                    According to Candidates
                    <span> :- {ques?.candidate_answers}</span>
                  </p>
                </div>
              </div>

              <div className="cTxt">
                <p>
                  प्रश्नों एवं उत्तर विकल्पों के संदर्भ में उपरोक्त आपत्तियों पर
                  सम्पूर्ण विचार किया गया। विचारोपरान्त हमारी संस्तुति निम्नवत्
                  प्रस्तावित हैः-
                </p>
              </div>
            </div>
          </div>
          <div className="page-number">
            <span>{`Page Number - ${index + 1}`}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuestionImgReport;
